<template>
    <v-layout v-if="!!getInvalidInputsFromForm.length" class="px-10 py-5">
        <v-card
            class="mx-auto"
            tile
            elevation="0"
            width="100%"
        >
            <v-list dense flat subheader>
                <v-subheader class="subtitle-1">
                    {{ $t('base.errors.requiredFieldsErrorList') }}
                </v-subheader>
                <v-list-item
                    v-for="(inputValidationMsg, index) in getInvalidInputsFromForm"
                    class="error-message-list py-1"
                    :data-testId="`error-message-list-${index}`"
                    :key="index"
                >
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="red--text text--darken-3 subtitle-2 text-wrap">
                            {{ inputValidationMsg }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
    </v-layout>
</template>

<script>
import { filter, get, map } from 'lodash';
import { mapGetters } from 'vuex';
import { getAttributeValueOrUndefined } from '@/utils.js';

export default {
    props: {
        formInputs: { type: Array, required: true },
        termsConditions: { type: Boolean, required: true },
        recaptchaToken: { type: String, required: false, default: '' },
        consentCollectData: { type: Boolean, required: true },
    },
    name: 'accessibility-required-fields',
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            getBaseMetadataById: 'services/getBaseMetadataById',
        }),
        getInvalidInputsFromForm() {
            if (!this.formInputs[0]) return [];

            let invalidInputs = map(filter(this.formInputs, input => {
                return input.valid === false || (getAttributeValueOrUndefined(input, 'valid') === 'false');
            }), input => {
                const metaId = getAttributeValueOrUndefined(input, 'data-meta-id') ?? -1;
                const descriptionTranslation = this.$i18n.t('inputValidationAccessibilityLang.' + (getAttributeValueOrUndefined(input, 'name') || input.id));

                if (/^inputValidationAccessibilityLang\./.test(descriptionTranslation)) {
                    const metaDescription = get(this.getBaseMetadataById(metaId), `description${this.upperLocale}`, '');
                    if(metaDescription === '') {
                        return undefined;
                    }
                    return this.$i18n.t('form.fieldIsRequired', [metaDescription]);
                }

                return this.$i18n.t('form.fieldIsRequired', [descriptionTranslation]);
            });

            // Find some required field(s) without description.
            if(invalidInputs.length > invalidInputs.filter(input => input).length) {
                invalidInputs = [
                    ...invalidInputs,
                    this.$i18n.t('form.unknownFieldRequired'),
                ];
            }

            invalidInputs = invalidInputs.filter(input => input);

            if (!this.recaptchaToken) {
                invalidInputs = [
                    ...invalidInputs,
                    this.$i18n.t('form.fieldIsRequired', [this.$i18n.t('inputValidationAccessibilityLang.recaptcha')]),
                ];
            }

            if (!this.termsConditions) {
                invalidInputs = [
                    ...invalidInputs,
                    this.$i18n.t('form.fieldIsRequired', [this.$i18n.t('inputValidationAccessibilityLang.terms_agreement')]),
                ];
            }
            if (!this.consentCollectData) {
                invalidInputs = [
                    ...invalidInputs,
                    this.$i18n.t('form.fieldIsRequired', [this.$i18n.t('inputValidationAccessibilityLang.privacy_policy_agreement')]),
                ];
            }

            return invalidInputs;
        },
    },
};
</script>

<style scoped lang="scss">
.error-message-list {
    min-height: 20px;
}
</style>
